/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ActorType = {
    CLIENT: 'CLIENT',
    USER: 'USER',
    SYSTEM: 'SYSTEM',
    ACCOUNTANT_USER: 'ACCOUNTANT_USER'
} as const;
export type ActorType = typeof ActorType[keyof typeof ActorType];

